import order_box from "../assets/images/My-Orders-Icon.png";
import faq_box from "../assets/images/FAQ-Icon.png";

const menus = [
  { path: "/orders", title: "My Orders", img: order_box },
  { path: "/faq-items", title: "FAQ,s", img: faq_box },
];

export default Object.freeze(menus);
